export const selectAllCities = (state) => state.mainReducer.cities;
